import {Country} from "./country";

export class OnboardingBsa {
  achTransactions?: boolean;
  wireTransferDomestic? : boolean;
  wireTransferInternational? : boolean;
  internationalCountryList : Country[] = [];
  cashTransactions? : boolean;
  useDebitCard? : boolean;
  useChecks? : boolean;
}
